<script lang="ts">
    export let width = '24';
</script>

<svg xmlns="http://www.w3.org/2000/svg" {width} height="33" viewBox="0 0 24 33" class="fill-none stroke-1" stroke="currentColor">
    <rect x="0.5" y="9.5" width="23" height="23" />
    <path d="M17.28 9.64V6.387C17.28 3.41184 14.916 1 12 1C9.08391 1 6.71997 3.41184 6.71997 6.387V9.64" />
</svg>
